import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { DashboardT } from 'business/definitions';
import { buildPublicTokenSearchParams } from 'helpers/urlHelpers';
import { useGetConvertedSlug } from 'hooks/useGetConvertedSlug';
import type { HttpError } from 'store/APIClient';
import { RQAPICallWithData } from 'store/APIClient';
import { useSelector } from 'store/hooks';

const useAPIGetDashboard = (
    dashboardSlug: string | null | undefined,
    publicToken?: string,
    notifyError: boolean = true,
): UseQueryResult<DashboardT, HttpError> => {
    const { isAuthenticated } = useSelector((state) => state.vision);

    const convertedSlug = useGetConvertedSlug(dashboardSlug);
    const query = !isAuthenticated
        ? `?${buildPublicTokenSearchParams(publicToken)}`
        : '';

    return useQuery({
        queryKey: ['getDashboard', convertedSlug, query],
        queryFn: async () => {
            const response = await RQAPICallWithData<DashboardT>({
                endpoint: `explore/dashboard/${convertedSlug}${query}`,
                method: 'GET',
            });
            return response.content.data;
        },
        enabled: !!dashboardSlug,
        meta: {
            useGlobalOnError: notifyError,
            ignoredErrorStatuses: [403],
        },
    });
};

export default useAPIGetDashboard;
